import React, { useState } from "react"
import "./wise-journey.scss"
import Modal from "../Modal"

const WiseJourney = props => {
  const { data } = props

  const [videoData, setVideoData] = useState(null)
  const [openCls, setOpenCls] = useState("w3-hide")

  const handleClose = () => {
    document.documentElement.classList.remove("pw-no-scroll")
    closeVideoModal()
  }

  const handleVideoModal = () => {
    setVideoData(data)
    setOpenCls("w3-show")
  }

  const closeVideoModal = () => {
    setVideoData(null)
    setOpenCls("w3-hide")
    document.body.classList.remove("pw-no-scroll")
  }

  let thumbnail =
   data && data.thumbnail && data.thumbnail.sourceUrl ;
  if (!thumbnail) {
    thumbnail = `https://vumbnail.com/${data.videoId}.jpg`
  }

  return (
    <div className="w3-content w3-center pw-wj-detail-container pw-wj-mobile">
      <div className=" pw-wj-detail-text-container">
        <div className=" pw-wj-detail-text-content">
          <div
            className=" pw-wj-img-modal"
            style={{ cursor: "pointer", position: "relative" }}
          >
            <div
              className="pw-vc-play-btn"
              onClick={() => handleVideoModal()}
            />
            <img
              loading="lazy"
              src={thumbnail}
              alt="thumbnail"
              onClick={() => handleVideoModal()}
              className="pw-wise-img"
              style={{ maxWidth: "100%" }}
            />
            {videoData ? (
              <Modal
                openCls={openCls}
                closeVideoModal={closeVideoModal}
                data={videoData}
                customClass="pw-video-modal"
              >
                <div className="w3-display-container">
                  <div className="pw-video-close" onClick={() => handleClose()}>
                    <div className="pw-close-btn" />
                  </div>
                </div>
                <div className="pw-video-container">
                  <iframe
                    src={
                      data && data.vType === "vimeo"
                        ? `https://player.vimeo.com/video/${data.videoId}`
                        : `https://www.youtube.com/embed/${data.videoId}`
                    }
                    frameBorder="0"
                    webkitallowfullscreen="true"
                    mozallowfullscreen="true"
                    allowFullScreen
                  ></iframe>
                </div>
              </Modal>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
export default WiseJourney
